export enum AppTypes {
  React = 'reactApp',
  ReactLegacySession = 'reactAppLegacy',
  ReactLegacyNoSession = 'reactAppNoSessionLegacy',
  ReactLegacyPortalComponents = 'reactPortalComponentsLegacy',
  AngularLegacy = 'angularApp'
}
